<template>
  <header>
    <div class="logo">
      <img src="../assets/logo.png" alt="WebMo Logo" />
    </div>
    <div class="headline uk-container uk-container-xsmall uk-container-center">
      <div v-if="isSuccess">
        <h1>Congratulations</h1>
        <h3>Dear {{form.firstname}},</h3>
        <p>You successfully registered your WebMo domain <em>https://{{form.domain}}.webmo.online</em>.</p>
        <p>Please check the e-mail inbox for your email address <em>{{form.email}}</em>. You should receive a short confirmation email within a few minutes with the link to your WebMo. (If you don't see the email in your inbox, please also check your spam folder.)</p>
        <p>The registration link you will receive by email remains valid for the next 24 hours. If the link has expired your order will not be processed further.</p>
        <p>Thank you for the registration!</p>
        <p>Sincerely,<br/>Your WebMo Team</p>
      </div>
      <div v-else-if="isServiceRequestFailed">
        <h1>Your registration failed due to a network error</h1>
        <p>Unfortunately, your WebMo registration cannot be processed. In case this happened during your registration, no data has been sent to us.</p>
        <p>Please try reloading the site and please check if your internet connection is working.</p>
        <p>If none of the steps above work, please contact our <a href="mailto:support@webmo.info">support team</a>.</p>
      </div>
      <div v-else-if="isTokenExpired">
        <h1>Link expired - please register again</h1>
        <p>Unfortunately, the registration link has already expired, please <a href="https://register.webmo.info/" target="_blank" rel="noopener noreferrer">register again</a>.</p>
        <p>You have 3 days (72 hours) to confirm your registration link.</p>
        <p>If you don't get the registration email or have any trouble with the registration link, please contact our <a href="mailto:support@webmo.info">support team</a>.</p>
      </div>
      <div v-else>
        <h1>Your WebMo registration</h1>
        <p>Thank you for your interest in <a href="https://webmo.info/" target="_blank" rel="noopener noreferrer">WebMo</a>&mdash;the monitoring and collaboration software for development. Monitoring and collaboration have never been easier. Not convinced? Try out WebMo for free!</p>
        <p>You can test your trial version without any obligations. After the 30 day trial period we will ask you for your preferred payment method should you wish to continue using WebMo.</p>
        <p>Simply fill out this form and get your free trial.</p>
      </div>
    </div>
  </header>
</template>

<script>

const STATUS_INITIAL = 0, STATUS_PENDING = 1, STATUS_SUCCESS = 2,
      STATUS_FAILED = 3, STATUS_SERVICE_UNAVAILABLE = 4, STATUS_SERVICE_REQUEST_FAILED = 5;

export default {
  name: 'OrderFormHeader',

  created() {
    this.$eventHub.$on('updateFormData', value => {
      this.form = value;
    });
  },

  props: {
    formStatus: null,
    networkStatus: null,
  },

  data(){
    return {
      form: this.form,
    };
  },

  computed: {
    isInitial() {
      return this.formStatus === STATUS_INITIAL;
    },
    isPending() {
      return this.formStatus === STATUS_PENDING;
    },
    isSuccess() {
      return this.formStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.formStatus === STATUS_FAILED;
    },
    isServiceUnavailable() {
      return this.networkStatus === STATUS_SERVICE_UNAVAILABLE;
    },
    isServiceRequestFailed() {
      return this.networkStatus === STATUS_SERVICE_REQUEST_FAILED;
    },
  },

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
header {
  margin: 0 0 1rem;
  text-align: left;
}

.logo {
  padding: 10px 0 0 10px;
  text-align: left;
  background: #fff;
}

.logo img {
  height: 50px;
  width: auto;
}

.headline {
  margin-top: 2rem;
}

</style>
